<template>
    <div class="prp-table-container">
        <h5>Resultados de Votos en:</h5>
        <h1>{{data.desc_centro}} - {{data.centro}}</h1>
        <v-row>

        </v-row>
        <v-row>

            <button @click="toggleDivisiones()" v-bind:class="showDivisiones?'active accordion':'accordion'" >Divisiones</button>
            <div class="panel" v-if='showDivisiones'>
                <v-col v-for='division in divisiones' cols='12' md='12' >
                    <DivisionResults
                        v-bind:data=division
                    />
                </v-col>
            </div>
        </v-row>
    </div>
</template>

<script>

import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import VueApexCharts from 'vue-apexcharts';
import ResultsDivision from './ResultsDivision';
import DivisionResults from './DivisionResults';

export default {
    props: ['data','colores','hexa_colors'],
    components: {
        DivisionResults,
        ResultsDivision,
        ScaleLoader,
        apexchart: VueApexCharts,
    },

    data: () => ({
        loading:false,
        showDivisiones :false,
        seriesparticipacion : [],
        seriesvotes:[],
        divisiones :[],
        headers: [
            {
                text: 'Planilla Participante',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            { text: 'Votos Ejercidos', value: 'total' },
        ],
        chartOptionsvotes: {
            chart: {
                width: 380,
                type: 'bar',
            },

            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        chartOptionsparticipacion: {
            chart: {
                width: 380,
                type: 'pie',
            },
            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    }),
    methods: {
        loadOptions: function() {
            console.log(this.data.divisiones)
            this.divisiones =  this.data.divisiones;
        },
        toggleDivisiones: function(){
            this.showDivisiones = !this.showDivisiones;

        },
    },
    created() {
        this.loadOptions();
    },
}
</script>
<style>
.accordion {
    background-color: #eee;
    color: #444;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 15px;
    transition: 0.4s;
}

.active, .accordion:hover {
    background-color: #ccc;
}

.accordion:after {
    content: '\002B';
    color: #777;
    font-weight: bold;
    float: right;
    margin-left: 5px;
}

.active:after {
    content: "\2212";
}

.panel {
    padding: 0 18px;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
}
</style>
